import { CloudinaryImage } from "@/features/common/components/CloudinaryImage";
import { QuickViewPhoto } from "@/features/common/components/QuickViewPhoto";
import { SelectablePhotoWrapper } from "@/features/modelPhoto/components/SelectablePhotoWrapper";
import { useEditModelAlbumFormDialogContext } from "@/features/modelPhoto/contexts/useEditModelAlbumFormContext";
import { ModelPhotoFragment } from "@/generated/graphql-hooks";

type ModelPhotoProps = {
  alt: string;
  modelPhoto: ModelPhotoFragment;
};

export const ModelPhoto = ({ alt, modelPhoto }: ModelPhotoProps) => {
  const { mode } = useEditModelAlbumFormDialogContext();

  return (
    <div className="relative mb-2">
      <SelectablePhotoWrapper value={modelPhoto.id} disabled={mode === "view"}>
        <QuickViewPhoto>
          <CloudinaryImage
            className="rounded-lg"
            publicId={modelPhoto.publicId}
            alt={alt}
            width={modelPhoto.width}
            height={modelPhoto.height}
            key={modelPhoto.id}
          />
        </QuickViewPhoto>
      </SelectablePhotoWrapper>
    </div>
  );
};
